"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRectSize = void 0;
var immutable_1 = require("../../immutable");
exports.IRectSize = (0, immutable_1.IRecord)({ height: 0, width: 0 });
